import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components'
import { rem } from '@mantine/core'

import { CarouselTag } from '../CarouselTag'

export const cssCategoryItem = css`
  padding: 0.375rem 0.75rem;
  display: inline-flex;
  gap: 0.25rem;
  align-items: center;
  white-space: nowrap;
  background-color: ${theme.colors.gray100};
  backdrop-filter: blur(0.83rem);
  border-radius: 0.5rem;

  .hhg-icon {
    width: 1.25rem;
    height: 1.25rem;
    line-height: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }
  }

  .label {
    color: ${theme.colors.gray800};
    font-size: 0.875rem;
    line-height: 1.4;
    letter-spacing: -0.2px;
  }
`

export const cssCategoryItemMobile = css`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  text-align: center;
  position: relative;

  .hhg-icon {
    width: 100%;
    border-radius: 0.75rem;
    /* border: 1px solid ${theme.colors.gray100}; */
    border: ${theme.colors.neutral50};
    background-color: ${theme.colors.neutral50};
    aspect-ratio: 1;
    line-height: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 48px;
      height: 48px;
      object-fit: contain;
      object-position: center;
    }
  }

  .new-tag {
    background-color: ${theme.colors.pink800};
    color: ${theme.colors.white};
    border-radius: ${rem(6)};
    padding: 0 ${rem(4)};
    font-size: ${rem(10)};
    line-height: ${rem(16)};
    text-transform: uppercase;
    position: absolute;
    top: ${rem(8)};
    right: ${rem(8)};
  }

  .label {
    color: ${theme.colors.gray800};
    font-size: 0.6875rem;
    line-height: 1rem;
    letter-spacing: -0.2px;
    font-weight: 500;
  }
`

export const StyledCategoryItem = styled.a`
  ${cssCategoryItem}
`

export const StyledCategoryItems = styled.a`
  ${cssCategoryItemMobile}
  @media(min-width: 768px) {
    .hhg-icon {
      padding: 0.75rem 0rem;
      height: ${rem(72)};
      width: ${rem(136.5)};
    }

    .new-tag {
      top: ${rem(-6)};
      right: ${rem(-6)};
    }
  }
`

export const StyledCarouselTag = styled(CarouselTag)`
  & .mantine-Carousel-viewport {
    padding: ${rem(24)} 0 0;
  }

  .mantine-Carousel-controls {
    margin-inline: -1px;

    .mantine-Carousel-control {
      > div {
        padding-left: ${rem(10)};
      }

      + .mantine-Carousel-control {
        > div {
          padding-left: 0;
          padding-right: ${rem(10)};
        }
      }
    }
  }
`
